/* Zeus pre-order label.
 *
 * Relabels the Add to cart button and puts a short note under it, for products
 * carrying custom.preorder. Runs only when zeus-preorder.liquid has rendered
 * the data block, so it is inert everywhere else.
 *
 * Dawn replaces the whole product-form section on a variant change, which wipes
 * anything injected into it - so this re-applies after each change, the same way
 * zeus-variant-cards does. It also watches the button's own subtree: Dawn
 * rewrites the label text when availability changes, which would otherwise put
 * "Add to cart" back a moment after we set it.
 */
(() => {
  const el = document.getElementById('zeus-preorder-data');
  if (!el) return;
  let data;
  try {
    data = JSON.parse(el.textContent);
  } catch {
    return;
  }
  const LABEL = String(data?.label || 'Pre-order').trim();
  const NOTE = String(data?.note || '').trim();
  if (!LABEL) return;

  const buttons = () => [...document.querySelectorAll('.product-form__submit[name="add"]')];

  let applying = false;
  const apply = () => {
    if (applying) return;
    applying = true;
    for (const btn of buttons()) {
      // A genuinely unavailable variant stays "Sold out" - pre-order is about
      // selling stock we do not have yet, not about overriding Dawn's disabled
      // state when a variant cannot be bought at all.
      if (btn.disabled) continue;

      const span = btn.querySelector('span:not(.visually-hidden)') || btn.querySelector('span');
      if (span && span.textContent.trim() !== LABEL) span.textContent = LABEL;
      btn.classList.add('zeus-preorder__btn');

      if (NOTE) {
        const form = btn.closest('product-form, .product-form') || btn.parentElement;
        if (form && !form.querySelector('.zeus-preorder__note')) {
          const p = document.createElement('p');
          p.className = 'zeus-preorder__note';
          p.textContent = NOTE;
          btn.insertAdjacentElement('afterend', p);
        }
      }
    }
    applying = false;
  };

  // Dawn swaps the section markup out, so re-apply rather than holding a node.
  const section = document.querySelector('[data-section-id], section') || document;
  section.addEventListener('change', () => setTimeout(apply, 60), true);

  // And re-apply if Dawn rewrites the label underneath us.
  const mo = new MutationObserver(() => {
    if (!applying) apply();
  });
  const watch = () => {
    for (const btn of buttons()) mo.observe(btn, { childList: true, subtree: true, characterData: true });
  };

  apply();
  watch();
  setTimeout(() => {
    apply();
    watch();
  }, 400);
})();
